import { FC } from 'react'

import { Container, PageHeading } from '~/components'
import { ContactMethods } from '~/features/common/contact-methods'
import { SpaceIncludingOffice } from '~/models/types'

import { PlanContactForm, PlanDetailCard, PlanInfoCard } from '../components'

type PlanContactPageProps = {
  plan: SpaceIncludingOffice
}

export const PlanContactPage: FC<PlanContactPageProps> = ({ plan }) => {
  return (
    <main>
      <div className="bg-grayBg md:p-[38px]">
        <Container className="flex max-w-[600px] flex-col gap-y-10 bg-white py-6 md:rounded-lg md:px-6">
          <PageHeading>お問い合わせ</PageHeading>

          <section aria-label="office-info-section">
            <div className="flex flex-col gap-y-2">
              <h3 className="text-body font-normal">お問い合わせするプラン</h3>
              <div className="flex flex-col gap-y-4 border px-4 py-4 pb-4">
                <PlanInfoCard office={plan.office} plan={plan} />
                <PlanDetailCard {...plan} />
              </div>
            </div>
          </section>

          <ContactMethods
            note={`「${plan.office.name}（${plan.name}）の件で」とお伝えください`}
          />

          <section aria-label="plan-contact-form-section">
            <PlanContactForm availability={plan.availability} />
          </section>
        </Container>
      </div>
    </main>
  )
}
